var _mask, _path, _path2, _mask2, _path3, _mask3, _rect, _mask4, _rect2, _mask5, _rect3, _mask6, _rect4, _mask7, _rect5, _mask8, _rect6, _mask9, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGuestHouse = function SvgGuestHouse(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 50 38"
  }, props), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "guest-house_svg__a",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 16.43a.43.43 0 0 1 .43-.43h2.14a.43.43 0 0 1 .43.43v9.141a.43.43 0 0 1-.429.429H10.43a.43.43 0 0 1-.429-.429z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10.43 16v1h2.14v-2h-2.14zm2.57.43h-1v9.141h2V16.43zM12.571 26v-1H10.43v2h2.142zM10 25.571h1V16.43H9v9.141zm.429.429v-1c.315 0 .571.256.571.571H9c0 .79.64 1.429 1.429 1.429zM13 25.571h-1c0-.315.256-.571.571-.571v2c.79 0 1.429-.64 1.429-1.429zM12.57 16v1a.57.57 0 0 1-.57-.57h2c0-.79-.64-1.43-1.43-1.43zm-2.14 0v-1C9.64 15 9 15.64 9 16.43h2a.57.57 0 0 1-.57.57z",
    mask: "url(#guest-house_svg__a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinejoin: "round",
    d: "m25 6-12.5 8.929v22.357h24.857V14.714z"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "guest-house_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.7 13.5a2.5 2.5 0 0 1 5 0v1.342c0 .087-.072.158-.159.158h-4.684a.16.16 0 0 1-.158-.158z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M27.7 13.5h-1v1.342h2V13.5zM27.54 15v-1h-4.684v2h4.684zm-4.842-.158h1V13.5h-2v1.342zm.158.158v-1c.465 0 .842.377.842.842h-2c0 .64.519 1.158 1.158 1.158zm4.842-.158h-1c0-.465.377-.842.842-.842v2c.64 0 1.158-.518 1.158-1.158zM25.2 11v1a1.5 1.5 0 0 1 1.5 1.5h2a3.5 3.5 0 0 0-3.5-3.5zm0 0v-1a3.5 3.5 0 0 0-3.5 3.5h2a1.5 1.5 0 0 1 1.5-1.5z",
    mask: "url(#guest-house_svg__b)"
  })), _mask3 || (_mask3 = /*#__PURE__*/React.createElement("mask", {
    id: "guest-house_svg__c",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 4,
    x: 16,
    y: 18,
    rx: 0.383
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 4,
    x: 16,
    y: 18,
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeWidth: 1.788,
    mask: "url(#guest-house_svg__c)",
    rx: 0.383
  })), _mask4 || (_mask4 = /*#__PURE__*/React.createElement("mask", {
    id: "guest-house_svg__d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 4,
    x: 16,
    y: 24,
    rx: 0.383
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 4,
    x: 16,
    y: 24,
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeWidth: 1.788,
    mask: "url(#guest-house_svg__d)",
    rx: 0.383
  })), _mask5 || (_mask5 = /*#__PURE__*/React.createElement("mask", {
    id: "guest-house_svg__e",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 4,
    x: 23,
    y: 18,
    rx: 0.383
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 4,
    x: 23,
    y: 18,
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeWidth: 1.788,
    mask: "url(#guest-house_svg__e)",
    rx: 0.383
  })), _mask6 || (_mask6 = /*#__PURE__*/React.createElement("mask", {
    id: "guest-house_svg__f",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 4,
    x: 23,
    y: 24,
    rx: 0.383
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 4,
    x: 23,
    y: 24,
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeWidth: 1.788,
    mask: "url(#guest-house_svg__f)",
    rx: 0.383
  })), _mask7 || (_mask7 = /*#__PURE__*/React.createElement("mask", {
    id: "guest-house_svg__g",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 4,
    x: 30,
    y: 18,
    rx: 0.383
  }))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 4,
    x: 30,
    y: 18,
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeWidth: 1.788,
    mask: "url(#guest-house_svg__g)",
    rx: 0.383
  })), _mask8 || (_mask8 = /*#__PURE__*/React.createElement("mask", {
    id: "guest-house_svg__h",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 4,
    x: 30,
    y: 24,
    rx: 0.383
  }))), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 4,
    x: 30,
    y: 24,
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeWidth: 1.788,
    mask: "url(#guest-house_svg__h)",
    rx: 0.383
  })), _mask9 || (_mask9 = /*#__PURE__*/React.createElement("mask", {
    id: "guest-house_svg__i",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21 30.383c0-.211.172-.383.383-.383h7.234c.211 0 .383.172.383.383v6.234a.383.383 0 0 1-.383.383h-7.234a.383.383 0 0 1-.383-.383z"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M20.106 30.383c0-.705.572-1.277 1.277-1.277h7.234c.705 0 1.277.572 1.277 1.277l-1.788.51h-6.212zM29 37h-8zm-7.617 0a1.277 1.277 0 0 1-1.277-1.277v-5.34c0-.705.572-1.277 1.277-1.277l.51 1.788V37zm7.234-7.894c.705 0 1.277.572 1.277 1.277v5.34c0 .705-.572 1.277-1.277 1.277h-.51v-6.106z",
    mask: "url(#guest-house_svg__i)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    d: "M25 31v6"
  })));
};
export default SvgGuestHouse;